import React, { PureComponent } from 'react';
import './WND.css';
import BUTTON from './BUTTON';
import ICONS from './ICONS';

// Main window class
class WND extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            layer: window.WINAPI.GetWindowLayer(this.props.hwnd),
            activeWindow: window.WINAPI.GetActiveWindow()
        };

        var defaultSize = this.defaultSize();
        defaultSize.w = Math.min(defaultSize.w, window.innerWidth - 50);
        defaultSize.h = Math.min(defaultSize.h, window.innerHeight - 100);
        // x y w h is_maximized
        this.state.position = [props.initialPositionX, props.initialPositionY, defaultSize.w, defaultSize.h, !!props.initialIsMaximized];

        if (this.defaultPosition() == 'center') {
            this.state.position[0] = Math.round((window.innerWidth - defaultSize.w) / 2);
            this.state.position[1] = Math.round((window.innerHeight - defaultSize.h) / 2);
        }

        // for window moving
        this.isMoving = false;
        this.moveOffset = [0, 0];
    }

    componentWillMount() {
        this.cursorMoveHandler =(event) => {
            if (this.isMoving) {
                let oldPosition = this.state.position;
                let mousePos = window.WINAPI.GetCursorPos();
        
                this.setState({ position: [event.clientX - this.moveOffset[0],
                        event.clientY - this.moveOffset[1],
                        oldPosition[2], oldPosition[3], false] });
            }
        };
        window.addEventListener("mousemove", this.cursorMoveHandler);

        this.mouseUpHandler = (event) => {
            this.isMoving = false;
        };
        window.addEventListener("mouseup", this.mouseUpHandler);

        this.activeWindowHandler = window.WINAPI.SetWinEventHook("focus", () => {
            let newState = {
                layer: window.WINAPI.GetWindowLayer(this.props.hwnd),
                activeWindow: window.WINAPI.GetActiveWindow()
            };

            if (newState.activeWindow != this.props.hwnd &&
                this.state.activeWindow == this.props.hwnd) {
                this.onFocusLost();
            }

            this.setState(newState);
        });
    }

    onFocusLost() {
        // To be overridden
    }

    componentWillUnmount() {
        window.removeEventListener("mousemove", this.cursorMoveHandler);
        window.removeEventListener("mouseup", this.mouseUpHandler);
        window.WINAPI.UnhookWinEvent("focus", this.activeWindowHandler);
    }

    defaultSize() {
        return {w: 800, h: 600};
    }

    resizable() {
        return true;
    }

    canMinimize() {
        return true;
    }

    defaultPosition() {
        return null; // or 'center'
    }

    appearOnTaskbar() {
        return true;
    }

    titlebarMouseDown(event) {
        this.isMoving = !this.state.position[4]; // Only move if not maximized
        this.moveOffset = [event.clientX - this.state.position[0], event.clientY - this.state.position[1]];
    }

    titlebarTouchStart(event) {
        this.takeFocus();
        
        let touch = event.changedTouches[0];
        this.moveOffset = [touch.pageX - this.state.position[0], touch.pageY - this.state.position[1]];
    }

    titlebarTouchMove(event) {
        if (!this.state.position[4]) {
            let oldPosition = this.state.position;
            let touch = event.changedTouches[0];
    
            this.setState({ position: [touch.pageX - this.moveOffset[0],
                    touch.pageY - this.moveOffset[1],
                    oldPosition[2], oldPosition[3], false] });
        }
    }

    title() {
        return "Error";
    }

    icon() {
        return null;
    }

    // Override me
    applicationContent() {
        return <div>Application has experienced an internal error</div>;
    }

    takeFocus() {
        if (this.state.activeWindow != this.props.hwnd) {
            window.WINAPI.SetActiveWindow(this.props.hwnd);
        }
    }

    toggleMaximized() {
        let oldPosition = this.state.position;

        this.setState({ position: [oldPosition[0], oldPosition[1],
                oldPosition[2], oldPosition[3], !oldPosition[4]] });
    }

    render() {
        var style = {
            zIndex: this.state.layer
        };

        let isMaximized = this.state.position[4];
        if (isMaximized) {
            // Maximized
            style.width = "100%";
            style.height = "100%";
        } else {
            style.top = (this.state.position[1]) + 'px';
            style.left = (this.state.position[0]) + 'px';
            style.width = (this.state.position[2]) + 'px';
            style.height = (this.state.position[3]) + 'px';
        }

        var icon;

        if (this.icon()) {
            icon = <div className="wnd-titlebar-icon"
                style={{backgroundImage: "url(" + this.icon() + ")"}}></div>;
        }

        let active = this.state.activeWindow == this.props.hwnd;

        var maximizeButton;
        if (isMaximized) {
            maximizeButton = <BUTTON className="restore" onPress={this.toggleMaximized.bind(this)}><img src={ICONS.RESTORE} /></BUTTON>;
        } else {
            maximizeButton = <BUTTON className="maximize" onPress={this.toggleMaximized.bind(this)}><img src={ICONS.MAXIMIZE} /></BUTTON>;
        }

        return (
            <div className={"wnd" + (active ? " wnd-active" : "") + (isMaximized ? " wnd-maximized" : "")}
                style={style}
                onMouseDown={this.takeFocus.bind(this)}>
                <div className="wnd-inner">
                    <div className="wnd-titlebar"
                        onMouseDown={this.titlebarMouseDown.bind(this)}
                        onTouchStart={this.titlebarTouchStart.bind(this)}
                        onTouchMove={this.titlebarTouchMove.bind(this)}>
                        {icon}
                        <div className="wnd-titlebar-title">{this.title()}</div>
                        <div className="wnd-titlebar-buttons">
                            {this.canMinimize() ? <BUTTON className="minimize"><img src={ICONS.MINIMIZE} /></BUTTON> : null}
                            {this.resizable() ? maximizeButton : null}
                            <BUTTON className="close" onPress={() => {
                                window.WINAPI.CloseWindow(this.props.hwnd);
                            }}><img src={ICONS.CLOSE} /></BUTTON>
                        </div>
                    </div>
                    <div className="wnd-clientarea">
                        {this.applicationContent()}
                    </div>
                </div>
            </div>
        );
    }
}

export default WND;



// WEBPACK FOOTER //
// ./src/walleris/WND.js